import { defineMessages } from 'react-intl'

export const notAvailableHostMessages = defineMessages({
  notAvailableHostTitle: {
    id: 'notAvailableHost.notAvailableHostTitle',
    description: 'Not available host title',
    defaultMessage: 'Home is offline',
  },
  sysMonUnavailableTitle: {
    id: 'notAvailableHost.sysMonUnavailableTitle',
    description: 'Not available host label',
    defaultMessage: 'System Monitor is not available',
  },
})

export const mainInfoHomeStatus = defineMessages({
  onlineHomeStatus: {
    id: 'mainInfoHomeStatus.onlineHomeStatus',
    description: 'Online home status',
    defaultMessage: 'Home Online',
  },
  offlineHomeStatus: {
    id: 'mainInfoHomeStatus.offlineHomeStatus',
    description: 'Offline home status',
    defaultMessage: 'Home Offline',
  },
})

export const mainInfoCardsMessages = defineMessages({
  overallStatusCardTitle: {
    id: 'mainInfoCardsMessages.overallStatusCardTitle',
    description: 'Overall system status card title',
    defaultMessage: 'Overall System Status',
  },
  overallStatusCardGoodLabel: {
    id: 'mainInfoCardsMessages.overallStatusCardGoodLabel',
    description: 'Overall system status good label',
    defaultMessage: 'Good',
  },
  averageLoadCardTitle: {
    id: 'mainInfoCardsMessages.averageLoadCardTitle',
    description: 'System load card title',
    defaultMessage: 'System Load',
  },
  freeSpaceCardTitle: {
    id: 'mainInfoCardsMessages.freeSpaceCardTitle',
    description: 'Free space card title',
    defaultMessage: 'Free Space',
  },
  uptimeCardTitle: {
    id: 'mainInfoCardsMessages.uptimeCardTitle',
    description: 'Uptime card title',
    defaultMessage: 'Uptime',
  },
})

export const mainInfoMonitoringAccess = defineMessages({
  monitoringAccess: {
    id: 'mainInfoMonitoringAccess.monitoringAccess',
    description: 'Main Info Monitoring Access label',
    defaultMessage: 'Monitoring Access',
  },
  accessGranted: {
    id: 'mainInfoMonitoringAccess.accessGranted',
    description: 'Main Info Access Granted label',
    defaultMessage: 'Monitoring Access',
  },
})

export const mainInfoHomeUID = defineMessages({
  homeUID: {
    id: 'mainInfoHomeUID.homeUID',
    description: 'Main Info Home UID label',
    defaultMessage: 'Home UID',
  },
  copied: {
    id: 'mainInfoHomeUID.copied',
    description: 'Main Info Home UID copied label ',
    defaultMessage: 'Copied!',
  },
  copy: {
    id: 'mainInfoHomeUID.copy',
    description: 'Main Info Home UID copy label ',
    defaultMessage: 'Copy',
  },
})
